function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SaitoUser = require('./../../../lib/saito/ui/saito-user/saito-user');
var PostTemplate = require('./post.template');
var SaitoOverlay = require('./../../../lib/saito/ui/saito-overlay/saito-overlay');
var SaitoInput = require('./../../../lib/saito/ui/saito-input/saito-input');
var SaitoLoader = require('./../../../lib/saito/ui/saito-loader/saito-loader');
var JSON = require('json-bigint');
var Post = /*#__PURE__*/function () {
  function Post(app, mod) {
    var tweet = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    _classCallCheck(this, Post);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(this.app, this.mod, true, true, false);
    this.images = [];
    this.tweet = tweet; //For reply or Retweet
    this.loader = new SaitoLoader(app, mod);
    this.render_after_submit = 0;
    this.file_event_added = false;
    this.type = 'Post';
  }
  return _createClass(Post, [{
    key: "render",
    value: function render() {
      var _this = this;
      var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      this.container = container ? '.tweet-container ' : '.saito-overlay ';
      this.id = container ? 'tweet-overlay-embedded' : 'tweet-overlay';
      if (container) {
        if (document.getElementById(this.id)) {
          this.app.browser.replaceElementById(PostTemplate(this.app, this.mod, this), this.id);
        } else {
          this.app.browser.addElementAfterSelector(PostTemplate(this.app, this.mod, this), container);
        }
      } else {
        this.overlay.show(PostTemplate(this.app, this.mod, this));
      }

      //
      //
      //

      if (!this.input) {
        this.input = new SaitoInput(this.app, this.mod, this.container + '.tweet-overlay-content', this.id);
      }
      if (!this.user) {
        this.user = new SaitoUser(this.app, this.mod, this.container + ".tweet-overlay-header", this.mod.publicKey, "create a text-tweet".concat(this.app.browser.isMobileBrowser() ? '' : ' or drag-and-drop images', "..."));
      }
      this.input.display = 'large';
      this.input.placeholder = "What's happening";
      if (this.type == 'Retweet') {
        this.input.placeholder = 'optional comment';
        this.user.notice = 'add a comment to your retweet or just click submit...';
      }
      if (this.type == 'Edit') {
        this.input.placeholder = this.tweet.text || '';
        this.user.notice = 'tweets are editable for a brief period after posting...';
      }
      if (this.type == 'Reply') {
        this.input.placeholder = 'my reply...';
        this.user.notice = 'add your comment to the tweet...';
      }
      this.input.callbackOnReturn = function () {
        _this.postTweet();
      };
      this.input.callbackOnUpload = /*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(file) {
          var type, resized_img;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                if (!(_this.images.length >= 4)) {
                  _context.n = 1;
                  break;
                }
                salert('Maximum 4 images allowed per tweet.');
                _context.n = 5;
                break;
              case 1:
                if (!file.includes('giphy.gif')) {
                  _context.n = 2;
                  break;
                }
                _this.addImg(file);
                _context.n = 5;
                break;
              case 2:
                type = file.substring(file.indexOf(':') + 1, file.indexOf(';'));
                if (!_this.mod.allowed_upload_types.includes(type)) {
                  _context.n = 4;
                  break;
                }
                _context.n = 3;
                return _this.app.browser.resizeImg(file);
              case 3:
                resized_img = _context.v;
                _this.addImg(resized_img);
                _context.n = 5;
                break;
              case 4:
                salert("Cannot upload ".concat(type, " image! Allowed file types: ").concat(_this.mod.allowed_upload_types.join(', ')));
              case 5:
                return _context.a(2);
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }();
      this.user.render();
      this.input.render();
      if (!this.app.browser.isMobileBrowser() || this.container == '.saito-overlay ') {
        this.input.focus(true);
      }
      if (this.type == 'Edit') {
        document.querySelector(this.container + '.post-tweet-textarea').innerHTML = this.tweet.text;
      }
      this.addCharacterLimit();
      this.attachEvents();
    }
  }, {
    key: "triggerClick",
    value: function triggerClick(querySelector) {
      if (document.querySelector(querySelector)) {
        document.querySelector(querySelector).click();
      }
    }
  }, {
    key: "addCharacterLimit",
    value: function () {
      var _addCharacterLimit = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _this2 = this;
        var wallet_balance, widget, lem, textarea;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return this.app.wallet.getBalance();
            case 1:
              wallet_balance = _context2.v;
              if (!Number(wallet_balance > 0)) {
                _context2.n = 2;
                break;
              }
              return _context2.a(2);
            case 2:
              this.app.browser.addElementToSelector("<div class=\"char-limit-container\">\n\t\t\t\t<div id=\"char-limit\">0</div>\n\t\t\t\t<div>/</div>\n\t\t\t\t<div>500</div>\n\t\t\t</div>", '.tweet-overlay-header');
              widget = document.querySelector('.char-limit-container');
              lem = document.getElementById('char-limit');
              textarea = document.querySelector('.post-tweet-textarea');
              if (lem && textarea) {
                textarea.addEventListener('input', function (e) {
                  var text = _this2.input.getInput(false);
                  lem.innerHTML = text.length;
                  if (text.length > 500) {
                    widget.classList.add('warning');
                  } else {
                    widget.classList.remove('warning');
                  }
                });
                textarea.addEventListener('keyup', function (e) {
                  var text = _this2.input.getInput(false);
                  lem.innerHTML = text.length;
                  if (text.length > 500) {
                    widget.classList.add('warning');
                  } else {
                    widget.classList.remove('warning');
                  }
                });
              } else {
                console.warn(lem, textarea);
              }
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function addCharacterLimit() {
        return _addCharacterLimit.apply(this, arguments);
      }
      return addCharacterLimit;
    }()
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this3 = this;
      var post_self = this;
      post_self.images = [];
      if (post_self.file_event_added == false) {
        post_self.app.browser.addDragAndDropFileUploadToElement(this.id, post_self.input.callbackOnUpload, false);
        post_self.file_event_added = true;
      }

      //
      if (document.querySelector(this.container + '.saito-file-uploader')) {
        document.querySelector(this.container + '.saito-file-uploader').style.display = 'none';
      }
      try {
        document.querySelector(this.container + '#post-tweet-button').addEventListener('click', function (e) {
          _this3.postTweet();
        });
      } catch (err) {}
    }
  }, {
    key: "deleteTweet",
    value: function () {
      var _deleteTweet = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _this$tweet;
        var keys, i, newtx;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              keys = [];
              if (this !== null && this !== void 0 && (_this$tweet = this.tweet) !== null && _this$tweet !== void 0 && _this$tweet.tx) {
                for (i = 0; i < this.tweet.tx.to.length; i++) {
                  if (!keys.includes(this.tweet.tx.to[i].publicKey)) {
                    keys.push(this.tweet.tx.to[i].publicKey);
                  }
                }
              }
              this.overlay.remove();
              data = {
                tweet_id: this.tweet.tx.signature
              };
              this.tweet.remove();
              _context3.n = 1;
              return this.mod.sendDeleteTransaction(this.app, this.mod, data, keys);
            case 1:
              newtx = _context3.v;
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function deleteTweet() {
        return _deleteTweet.apply(this, arguments);
      }
      return deleteTweet;
    }()
  }, {
    key: "postTweet",
    value: function () {
      var _postTweet = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var _this4 = this,
          _post_self$tweet;
        var check_length,
          post_self,
          text,
          wallet_balance,
          alternates,
          image,
          data,
          keys,
          i,
          qs,
          obj,
          _newtx,
          _data,
          _data2,
          _this$mod,
          newtx,
          _args4 = arguments;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              check_length = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : true;
              post_self = this;
              text = this.input.getInput(false); //
              //don't send empty posts
              //
              if (!(this.images.length == 0 && text.trim().length == 0 && this.type != 'Retweet')) {
                _context4.n = 1;
                break;
              }
              siteMessage('Post Empty', 1000);
              return _context4.a(2);
            case 1:
              if (!(check_length && text.length > 500)) {
                _context4.n = 4;
                break;
              }
              _context4.n = 2;
              return this.app.wallet.getBalance('SAITO');
            case 2:
              wallet_balance = _context4.v;
              if (!(Number(wallet_balance) == 0)) {
                _context4.n = 3;
                break;
              }
              siteMessage('Insufficient SAITO to Enable Oversized Posts...', 3000);
              return _context4.a(2);
            case 3:
              if (!(text.length > 1500)) {
                _context4.n = 4;
                break;
              }
              alternates = this.app.modules.returnModulesRespondingTo('post-content');
              if (!(alternates.length > 1)) {
                _context4.n = 4;
                break;
              }
              image = this.images.length ? this.images[0] : null;
              this.app.connection.emit('choose-post-location', text, image, alternates);
              this.app.connection.on('continue-with-redsquare', function () {
                _this4.app.connection.removeAllListeners('continue-with-redsquare');
                _this4.postTweet(false);
              });
              this.overlay.hide();
              return _context4.a(2);
            case 4:
              //
              // tweet data
              //
              data = {
                text: text
              };
              keys = this.input.getMentions();
              if (keys.length > 0) {
                // Shallow copy so we don't add reply-to's as mentions
                data['mentions'] = Array.from(keys);
              }

              //
              // any previous recipients get added to "to"
              //
              if (post_self !== null && post_self !== void 0 && (_post_self$tweet = post_self.tweet) !== null && _post_self$tweet !== void 0 && _post_self$tweet.tx) {
                for (i = 0; i < post_self.tweet.tx.to.length; i++) {
                  if (!keys.includes(post_self.tweet.tx.to[i].publicKey)) {
                    keys.push(post_self.tweet.tx.to[i].publicKey);
                  }
                }
              }

              //
              // saito-loader
              //
              post_self.overlay.remove();
              if (document.querySelector(this.container + '#' + this.id)) {
                document.querySelector(this.container + '#' + this.id).remove();
              }

              //Edit
              if (!(this.type === 'Edit')) {
                _context4.n = 6;
                break;
              }
              data = {
                text: text,
                tweet_id: this.tweet.tx.signature
              };
              qs = ".tweet-container > .tweet-".concat(this.tweet.tx.signature, " .tweet-body .tweet-text");
              obj = document.querySelector(qs);
              if (obj) {
                obj.innerHTML = text;
              }
              _context4.n = 5;
              return post_self.mod.sendEditTransaction(post_self.app, post_self.mod, data, keys);
            case 5:
              _newtx = _context4.v;
              return _context4.a(2);
            case 6:
              post_self.overlay.closebox = false;
              post_self.loader.show();
              if (post_self.images.length > 0) {
                data['images'] = post_self.images;
              }
              if (this.type == 'Reply') {
                this.tweet.num_replies++;
                this.mod.replyTweet(this.tweet);
                data = Object.assign(data, {
                  parent_id: this.tweet.tx.signature,
                  thread_id: this.tweet.thread_id
                });
              }

              //
              // We let the loader run for a half second to show we are sending the tweet
              // Start it up here because we may nope out of some rendering code for a pure retweet
              //
              setTimeout(function () {
                post_self.loader.hide();
                if (!_this4.mod.browser_active) {
                  siteMessage('Tweet sent', 1000);
                }
              }, 600);
              if (!(this.type == 'Retweet')) {
                _context4.n = 8;
                break;
              }
              data.signature = post_self.tweet.tx.signature;
              this.mod.retweetTweet(this.tweet);

              // We temporarily increase the number of retweets, this affects the next rendering
              // but only adjust tx.optional when we get confirmation from the blockchain
              this.tweet.num_retweets++;
              if (!((_data = data) !== null && _data !== void 0 && _data.text || (_data2 = data) !== null && _data2 !== void 0 && _data2.images)) {
                _context4.n = 7;
                break;
              }
              //
              // This is a quote tweet, treat as a sendTweet and attach original tweet as part of its content
              //
              data.retweet_tx = post_self.tweet.tx.serialize_to_web(this.app);
              _context4.n = 8;
              break;
            case 7:
              //
              // This is a pure retweet, treat similar to a like and send a specialize tx to update stats only
              //

              post_self.mod.sendRetweetTransaction(post_self.app, post_self.mod, data, this.tweet.tx);
              if (!this.tweet.retweeters.includes(post_self.mod.publicKey)) {
                this.tweet.retweeters.unshift(post_self.mod.publicKey);
              }
              if ((_this$mod = this.mod) !== null && _this$mod !== void 0 && (_this$mod = _this$mod.main) !== null && _this$mod !== void 0 && (_this$mod = _this$mod.mode) !== null && _this$mod !== void 0 && _this$mod.includes('tweet')) {
                this.tweet.render();
              }
              return _context4.a(2);
            case 8:
              _context4.n = 9;
              return post_self.mod.sendTweetTransaction(post_self.app, post_self.mod, data, keys);
            case 9:
              newtx = _context4.v;
              this.app.connection.emit('redsquare-render-new-post', newtx, this.tweet);
            case 10:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function postTweet() {
        return _postTweet.apply(this, arguments);
      }
      return postTweet;
    }()
  }, {
    key: "addImg",
    value: function addImg(img) {
      var post_self = this;
      var html = "<div class=\"post-tweet-img-preview\">\n        \t\t\t\t<img src=\"".concat(img, "\"/>\n        \t\t\t\t<i class=\"fa fa-times\"></i>\n       \t\t\t\t</div>");
      this.app.browser.addElementToSelector(html, this.container + '#post-tweet-img-preview-container');
      this.images.push(img);

      // attach img preview event
      // event added here because img-prievew is added dynamically
      var sel = this.container + '.post-tweet-img-preview';
      document.querySelectorAll(sel).forEach(function (elem) {
        elem.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          var array_position = e.target.getAttribute('data-id');
          e.target.parentNode.remove();
          post_self.images.splice(array_position, 1);
          document.querySelectorAll(this.container + '.post-tweet-img-preview').forEach(function (el2) {
            var array_position2 = el2.getAttribute('data-id');
            if (array_position2 > array_position) {
              el2.setAttribute('data-id', array_position2 - 1);
            }
          });
        });
      });
    }
  }]);
}();
module.exports = Post;